// import TypingEffect from "./pages/VideoShare/TypingEffect"

const Title = ({ title }) => (
  <h1
    css={{
      color: "white",
      width: "100%",
      fontSize: 30,
      minHeight: 29,
      fontWeight: 700,
      textAlign: "center",
      alignSelf: "start",
      margin: 0,
      whiteSpace: `pre-line`,
      // lineHeight: 26px,
    }}
  >
    {title}
    {/* <TypingEffect text={title} /> */}
    {/* {title} */}
  </h1>
)

export default Title
